<template>
  <div>
    <div class="sv-pic">
      <img :src="$img + showIntro.coverImg">
    </div>
    <div class="sv-name">{{showIntro.title}}</div>
    <div class="sv-intro">{{showIntro.intro}}</div>
    <mbFooter></mbFooter>
  </div>
</template>

<script>
  import mbFooter from "@/components/mobile/mbFooter";

  export default {
    components: {mbFooter},
    name: "mobile",
    data() {
      return {
        currentService: 0,
        serviceItem:[],
        showIntro: {}
      }
    },
    mounted() {
      this.$http.get('/api/skills/info/list').then((res)=>{
        this.serviceItem = res.data.rows
        console.log(this.serviceItem)
        this.showIntro = res.data.rows[this.$route.query.id]
      })
    }
  }
</script>

<style scoped>
  .sv-pic {
    width: 98.4vw;
    margin: 15.2vw auto 8vw;
  }

  .sv-pic img {
    width: 100%;
  }

  .sv-name {
    font-size: 1.125em;
    font-weight: bold;
    width: 90vw;
    margin: 0 auto 4.8vw;
  }

  .sv-intro {
    width: 90vw;
    font-size: .75em;
    line-height: 180%;
    letter-spacing: .1em;
    color: #768087;
    text-indent: 2em;
    margin: 0 auto 12vw;
    min-height: 15vh;
  }
</style>



// WEBPACK FOOTER //
// src/pages/service/mobile.vue